/* src/app/umbrella-common/components/binary-question/binary-question.style.scss */
.radio-button-group-wrapper .form-row {
  flex-wrap: nowrap;
}
.radio-button-group-wrapper .form-row .answer-part {
  min-width: 140px;
  padding-right: 0;
  margin-right: 30px;
}
.radio-button-group-wrapper .form-row .answer-part nb-radio {
  display: inline-block !important;
}
.radio-button-group-wrapper .form-row .question {
  font-size: 15px;
  line-height: 1.47;
  color: #585858 !important;
}
.validation-message {
  margin-top: 0 !important;
}
@media screen and (max-width: 767px) {
  .radio-button-group-wrapper .form-row {
    flex-direction: column-reverse;
  }
}
/*# sourceMappingURL=binary-question.style.css.map */
